import styled from "styled-components";
import { AddButton as BaseAddButton } from "components/Feed/FeedRightSidebar/FeedRightSidebar.styles";

export const SearchWrapper = styled.div`
  position: relative;
  width: 100%;
  max-width: 500px;
`;

export const SearchInputBox = styled.div`
  display: flex;
  align-items: center;
  border: 2px solid #fe2f67;
  border-radius: 10px;
  padding: 0.25rem 0.6rem;
`;

export const SearchInput = styled.input`
  flex: 1;
  border: none;
  outline: none;
  font-size: 1rem;
  color: #fe2f67;
  background: transparent;
  margin-left: 0.4rem;
`;

export const ResultsDropdown = styled.div`
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  width: 100%;
  max-height: 300px;
  overflow-y: auto;
  background: #ffffff;
  border-radius: 6px;
  box-shadow: 0 8px 16px rgba(0, 0, 0, 0.18);
  z-index: 1000;
`;

export const ResultItem = styled.div`
  display: flex;
  align-items: center;
  padding: 8px 12px;
  cursor: pointer;
  &:hover {
    background: #f3f5f7;
  }
`;

export const Avatar = styled.img`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 8px;
`;

export const ItemInfo = styled.div`
  display: flex;
  flex-direction: column;
`;

export const ItemName = styled.span`
  font-size: 14px;
  font-weight: 600;
  color: #050505;
`;

export const ItemType = styled.span`
  font-size: 12px;
  color: #65676b;
`;

export const AddUserButton = styled(BaseAddButton)`
  margin-left: auto;
  border-radius: 50%;
  position: relative; /* permite overlay */
  width: 32px;
  height: 32px;

  transition: background 0.2s, transform 0.2s, color 0.2s;
  &:hover {
    background: rgba(254, 47, 103, 0.12);
    color: #fe2f67;
    transform: scale(1.1);
  }

  /* estilo cuando está deshabilitado (cargando) */
  &[disabled] {
    cursor: default;
    color: #b0b0b0;
    &:hover {
      background: transparent;
      transform: none;
    }
  }
`;

export const SpinnerWrapper = styled.div`
  position: absolute;
  inset: 0; /* ocupa todo el botón */
  display: flex;
  align-items: center;
  justify-content: center;
`;
